import React from "react"
import { Dispatch } from "redux"

import { replaceHistoryState } from "client/utils"
import { addModal } from "client/store"

import RequirementAnswer from "client/pages/cc/requirementReview/answer"

const Open = (
    baseRoute: string,
    requirementId: number,
    revisionId: number,
    dispatch: Dispatch,
) => {
    replaceHistoryState(`${baseRoute}/requirement/${requirementId}/revision/${revisionId}`)

    dispatch(addModal({
        key: "answer",
        content: <RequirementAnswer requirementId={requirementId} revisionId={revisionId} />,
        onClose: () => {
            replaceHistoryState(baseRoute)
        },
    }))
}
export default Open
